'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _emailStyleTools = require('helpers/emailStyleTools');

var _priceString = require('helpers/priceString');

var _priceString2 = _interopRequireDefault(_priceString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HotelTotalFooter(props) {
  /**
  Returns per-night price description type title
  */
  function priceItemTitle(priceItem, t) {
    switch (priceItem.priceData.rateType) {
      case 'AveragePerNight':
        {
          return t('hotel.avg') + ': ';
        }

      case 'MinPrice':
        {
          return t('hotel.min') + ': ';
        }

      case 'MaxPrice':
        {
          return t('hotel.max') + ': ';
        }

      case 'PerNight':
        {
          return 'Price per night: ';
        }

      default:
        {
          return '';
        }
    }
  }

  /**
  Returns per-night price description total price and currency
  */
  function priceItemPrice(priceItem, selectedCurrencyFormat) {
    return !priceItem.priceData.isNotAvailable ? (0, _priceString2.default)(selectedCurrencyFormat, priceItem.priceData.totalPrice, priceItem.priceData.currency) : 'N/A';
  }

  /**
  Returns per-night price description tax
  */
  function priceItemTax(priceItem, selectedCurrencyFormat) {
    return !priceItem.priceData.isNotAvailable ? ' (' + (priceItem.priceData.includingTaxes ? 'incl. taxes' : 'excl. taxes') + (priceItem.priceData.taxPrice ? (0, _priceString2.default)(selectedCurrencyFormat, priceItem.priceData.taxPrice, priceItem.priceData.currency) : '') + ')' : '';
  }

  var components = props.components,
      option = props.option,
      total = props.total,
      totalCurrency = props.totalCurrency,
      footerMessage = props.footerMessage,
      t = props.t,
      selectedCurrencyFormat = props.selectedCurrencyFormat;


  var styleHotelPriceContainer = (0, _emailStyleTools.containerStyles)(components, 'HotelPriceContainer');
  var stylePricePerNightTitleLabel = (0, _emailStyleTools.textStyles)(components, 'PricePerNightTitleLabel');
  var stylePricePerNightValueLabel = (0, _emailStyleTools.textStyles)(components, 'PricePerNightValueLabel');
  var styleApproximateTotalValueLabel = (0, _emailStyleTools.textStyles)(components, 'ApproximateTotalValueLabel');
  var styleApproximateTotalTitleLabel = (0, _emailStyleTools.textStyles)(components, 'ApproximateTotalTitleLabel');

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'HotelTotalFooter' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleHotelPriceContainer, _emailStyleTools.padTen) },
          _react2.default.createElement(
            'table',
            { style: _emailStyleTools.fullMinimal, 'data-component': 'HotelTotalFooter__Sub' },
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { style: { verticalAlign: 'top', padding: '0', width: '70%' } },
                  _react2.default.createElement(
                    'table',
                    { style: _emailStyleTools.fullMinimal, 'data-component': 'HotelTotalFooter__Sub__PriceList' },
                    _react2.default.createElement(
                      'tbody',
                      null,
                      _react2.default.createElement(
                        'tr',
                        null,
                        option.optionPrice.priceItemList.map(function (priceItem, i) {
                          return _react2.default.createElement(
                            'td',
                            { key: i, style: _emailStyleTools.noPad },
                            _react2.default.createElement(
                              'span',
                              { style: stylePricePerNightTitleLabel },
                              priceItemTitle(priceItem, t)
                            ),
                            _react2.default.createElement(
                              'span',
                              { style: stylePricePerNightValueLabel },
                              priceItemPrice(priceItem, selectedCurrencyFormat)
                            ),
                            _react2.default.createElement(
                              'span',
                              { style: stylePricePerNightValueLabel },
                              priceItemTax(priceItem, selectedCurrencyFormat)
                            )
                          );
                        })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'table',
                    { style: _emailStyleTools.fullMinimal, 'data-component': 'HotelTotalFooter__Sub__PriceList' },
                    _react2.default.createElement(
                      'tbody',
                      null,
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          null,
                          _react2.default.createElement(
                            'span',
                            { style: stylePricePerNightValueLabel },
                            footerMessage
                          )
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'td',
                  { style: { verticalAlign: 'top', padding: '0', textAlign: 'right', width: '30%' } },
                  _react2.default.createElement(
                    'table',
                    { style: _emailStyleTools.fullMinimal, 'data-component': 'CarTotalFooter__Total' },
                    _react2.default.createElement(
                      'tbody',
                      null,
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          { style: _emailStyleTools.noPad },
                          _react2.default.createElement(
                            'span',
                            { style: styleApproximateTotalValueLabel },
                            (0, _priceString2.default)(selectedCurrencyFormat, total, totalCurrency)
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          { style: _emailStyleTools.noPad },
                          _react2.default.createElement(
                            'span',
                            { style: styleApproximateTotalTitleLabel },
                            t('hotel.total')
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    selectedCurrencyFormat: state.rendering.shopOptions.currencyFormat || state.templateApplication.templates.currentTemplate.currencyFormat
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(HotelTotalFooter);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Hotel/Email/Active/HotelTotalFooter.jsx
// module id = 1526
// module chunks = 0